import { REVIEW_DIFFICULTY_OPTION_LIST, REVIEW_PROBLEM_OPTION_LIST } from "./mathBankShared";

// 수학 복습 유형 & 난이도(2026-11-03 대표). 영어와 같은 복습 칸(ReviewSettingsPanel)의 복습 방식 바로 아래에 붙는다.
// 쌍둥이 문제면 수학 사이트의 닮은 문제로, 틀린 문제 그대로면 지금까지처럼 같은 문제로 다시 낸다(서버 math_bank_review.py).
const labelStyle = { fontSize: "0.78rem", fontWeight: 800, color: "#5B6670", margin: "16px 0 8px" };

const ChipRow = ({ optionList, value, onChange }) => (
  <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
    {optionList.map((one) => (
      <button
        key={one.value}
        type="button"
        className={`ws-filter-chip${value === one.value ? " active" : ""}`}
        onClick={() => onChange(one.value)}
      >
        {one.label}
      </button>
    ))}
  </div>
);

const MathReviewTypeField = ({ reviewProblem, onSetReviewProblem, reviewDifficulty, onSetReviewDifficulty }) => (
  <>
    <div style={labelStyle}>복습 유형</div>
    <ChipRow optionList={REVIEW_PROBLEM_OPTION_LIST} value={reviewProblem} onChange={onSetReviewProblem} />
    {reviewProblem === "twin" && (
      <>
        <div style={labelStyle}>쌍둥이 난이도</div>
        <ChipRow optionList={REVIEW_DIFFICULTY_OPTION_LIST} value={reviewDifficulty} onChange={onSetReviewDifficulty} />
      </>
    )}
  </>
);

export default MathReviewTypeField;
